export enum ButtonTypes {
    Yes = "yes",
    No = "no"
}

export {};